import * as USER from '@/store/constants/user';
import * as FCFS from '@/store/constants/fcfs';

import links from '@/config/links';
import {mapGetters} from 'vuex';

export default {
  name: 'Sidebar',
  props: {
    burgerMenuState: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      active: 'dashboard',
      links: links
    }
  },

  computed: {
    ...mapGetters({
      user: USER.GET_USER,
      fcfs: FCFS.GET_QUEUE_LIST
    }),

    user_initial() {
      const name =  this.user.name.split(' ');
      return name[0].charAt(0) + name[1].charAt(0) || "";
    }
  },

  methods: {
    getBadgeValue(item) {
      if (item) {
        const objectItem = item.toLowerCase();
        return (this[objectItem] || {}).total || 0;
      }

      return 0;
    },
    logout() {
      localStorage.clear();
      this.$router.push({name: 'Login'});
    },

    toggle() {
      this.$emit('side-bar-class', !this.burgerMenuState);
    }
  },

  created() {
    console.log(this.user);
  }
}



// WEBPACK FOOTER //
// ./src/views/Common/Sidebar/sidebar.js